import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { apiClient, useAuth } from "../../App";
import { Radar, Siren, GitPullRequestArrow } from "lucide-react";

const ITEMS = [
  { path: "/security-monitor", label: "Security Monitor", icon: Radar, superOnly: true },
  { path: "/incidents", label: "Incident Log", icon: Siren, superOnly: true },
  { path: "/change-log", label: "Change Log", icon: GitPullRequestArrow },
];

export function SecurityNav({ onNavigate }) {
  const { user } = useAuth();
  const location = useLocation();
  const isSuper = user?.role === "superuser";
  const [changeAccess, setChangeAccess] = useState(isSuper);

  useEffect(() => {
    if (isSuper) { setChangeAccess(true); return; }
    if (user?.role !== "admin") { setChangeAccess(false); return; }
    apiClient.get("/change-records/can-access").then((r) => setChangeAccess(r.data.allowed)).catch(() => setChangeAccess(false));
  }, [isSuper, user?.role]);

  const items = ITEMS.filter((i) => (i.superOnly ? isSuper : changeAccess));
  if (!items.length) return null;

  return (
    <>
      <div className="pt-4 pb-2 px-4">
        <span className="text-xs font-mono uppercase tracking-wider text-slate-400">Security</span>
      </div>
      {items.map(({ path, label, icon: Icon }) => (
        <Link key={path} to={path} onClick={onNavigate}
          className={`nav-item ${location.pathname === path ? "active" : ""}`}
          data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}>
          <Icon size={18} strokeWidth={1.5} />
          <span className="text-sm font-medium">{label}</span>
        </Link>
      ))}
    </>
  );
}
